import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('BillService', BillService);

  BillService.$inject = [
    'RestResource',
    '$translate',
    '$filter',
    'UtilService',
    'SessionService',
    'BillModalService',
    'WindowModalService',
    'FileSaver',
  ];

  function BillService(
    RestResource,
    $translate,
    $filter,
    UtilService,
    SessionService,
    BillModalService,
    WindowModalService,
    FileSaver
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'bills';

    var service = {
      getFilterCriteria: getFilterCriteria,
      getBills: getBills,
      getBill: getBill,
      saveBill: saveBill,
      deleteBill: deleteBill,
      downloadBillPdf: downloadBillPdf,
      openSendBillToProvider: openSendBillToProvider,
      changeBillStatus: changeBillStatus,
      openRelatedTransactions: openRelatedTransactions,
      getRelatedTransactions: getRelatedTransactions,
    };

    return service;

    ////////////////

    function getFilterCriteria() {
      var filterCriteria = {
        page: 1,
        sortDir: 'desc',
        sortedBy: 'date',
      };

      return filterCriteria;
    }

    function getBills(filterCriteria) {
      if (!filterCriteria) {
        filterCriteria = getFilterCriteria();
      }

      filterCriteria.company_id = SessionService.getSelectedAccountCompany().id;

      return RestResource.request(
        'get',
        apiUrl,
        filterCriteria,
        function (response) {
          response = response.data;

          if (response.meta) {
            return {
              items: response.data,
              meta: utils.getItemsMetaData(response, filterCriteria),
              totalAmounts: response.totalAmounts,
              sumItems: response.sumItems,
            };
          } else {
            return {
              items: response,
            };
          }
        },
        {}
      );
    }

    function getBill(id) {
      return RestResource.request(
        'get',
        apiUrl + '/' + id,
        {},
        function (response) {
          return response.data;
        },
        function () {
          // err
          return false; // err
        }
      );
    }

    function openSendBillToProvider(providerEmail, successCallback) {
      BillModalService.openSendBillToProvider(providerEmail, successCallback);
    }

    function saveBill(bill, payment_provider) {
      let method = 'post';
      let url = apiUrl;

      if (bill.id) {
        // edit
        method = 'put';
        url += '/' + bill.id;
      }

      function success(response) {
        let msg = bill.id ? 'BILL_MODIFIED' : 'BILL_ADDED';
        utils._successMsg($translate(msg));

        return {
          status: true,
          response: response.data,
        };
      }

      function failure(response) {
        return {
          status: false,
          response: response.data,
        };
      }

      return RestResource.request(
        method,
        url,
        { bill: bill, payment_provider: payment_provider },
        success,
        failure
      );
    }

    function deleteBill(bill, successCallback) {
      let url = apiUrl + '/' + bill.id;

      return RestResource.request(
        'delete',
        url + '?check_if_used=true',
        { company_id: bill.company_id },
        function () {
          let params = {
            title: 'DELETE_BILL',
            itemName: bill.bill_number,
            reason: 'DELETE_ITEM_REASON',
            successMsg: 'BILL_DELETED',
            company_id: bill.company_id,
          };

          utils.deleteItem(url, successCallback, params);
        },
        function (response) {
          utils.openModalError(response.data.error);
        }
      );
    }

    function changeBillStatus(item) {
      utils.changeItemStatus(apiUrl + '/' + item.id, item);
    }

    function downloadBillPdf(bill, lang) {
      var apiUrlPdf = apiUrl + '/' + bill.id + '/bill_pdf.pdf';

      return RestResource.request(
        'get',
        apiUrlPdf,
        { company_id: bill.company_id, lang: lang },
        function (response) {
          let blobVar = new Blob([response.data], { type: 'application/pdf' });

          FileSaver.saveAs(blobVar, $translate('BILL') + ' ' + bill.bill_number + '.pdf');
        },
        function () {}
      );
    }

    function openRelatedTransactions(transaction, provider) {
      let templateUrl = './app/ajs/bills/modals/bill-related-transactions-modal.html';

      let modalParams = {
        item: transaction,
        additionalParams: {
          providerId: provider.id,
        },
      };

      WindowModalService.open(templateUrl, modalParams);
    }

    function getRelatedTransactions(id, providerId) {
      const params = {
        skip_check_role: true,
        provider_id: providerId,
      };

      return RestResource.request(
        'get',
        apiUrl + '/' + id + '/related_transaction/',
        params,
        function (response) {
          return response.data;
        },
        function (err) {
          return err;
        }
      );
    }

    function hasRelatedTransactions(id, clientId) {
      const params = {
        skip_check_role: true,
        client_id: clientId,
      };

      return RestResource.request(
        'get',
        apiUrl + '/' + id + '/has_related_transactions/',
        params,
        function (response) {
          return response.data;
        },
        function (err) {
          return err;
        }
      );
    }
  }
})();
